import React from "react";
import { Container } from "react-bootstrap";
import styles from "./footer.module.css";
import { ImFacebook } from "react-icons/im";
import { FaYoutube } from "react-icons/fa";
import { FaPhone } from "react-icons/fa";
import { FaBuilding } from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";

function Footer() {
  return (
    <>
      <div className={styles.footer}>
        <Container>
          <div className={styles.footer__content}>
            <div className={styles.footer__follow}>
              <h4>تابعنا علي</h4>
              <a href="https://www.facebook.com/CoreTech.pts" target="_blank">
                <ImFacebook />
              </a>

              <a
                href="https://www.youtube.com/watch?v=d3PjZn54uxY"
                target="_blank"
              >
                <FaYoutube />
              </a>
            </div>
            <div className={styles.footer__reachus}>
              <h4>لتصل إلينا</h4>
              <p>
                <FaBuilding /> <span>العنوان</span> : الطابق الأول - برج الأمل -
                شارع المدينة المنورة - قشلاء السواحل - المناخ - بورسعيد
              </p>
              <p>
                <FaPhone /> 012-0707-7883
              </p>
              <p>
                <FaPhone /> 012-7201-7100
              </p>
              <p>
                <FaPhone /> 012-7201-7120
              </p>
              <p>
                <HiOutlineMail />
                <a href="mailto:info@coretechsolutions.online">
                  info@coretechsolutions.online
                </a>
              </p>
            </div>
            <div className={styles.footer__links}>
              <h4>الروابط</h4>
              <p>
                <a href="#home">الرئسيه</a>
              </p>
              <p>
                <a href="#about">من نحن</a>
              </p>
              <p>
                <a href="#services">الخدمات </a>
              </p>
              {/* <p>
                <a href="#work">أعمالنا</a>
              </p> */}
              <p>
                {" "}
                <a href="#contact">أتصل بنا</a>
              </p>
            </div>
          </div>
        </Container>
      </div>
      <div className={styles.copyright}>
        جميع الحقوق محفوظه &copy; 2023 لشركه <span>Core Tech Solutions</span>
      </div>
    </>
  );
}

export default Footer;
